"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getHiddenCssUtilityClass = getHiddenCssUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("@mui/utils/generateUtilityClasses"));
var _generateUtilityClass = _interopRequireDefault(require("@mui/utils/generateUtilityClass"));
function getHiddenCssUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('PrivateHiddenCss', slot);
}
const hiddenCssClasses = (0, _generateUtilityClasses.default)('PrivateHiddenCss', [
    'root',
    'xlDown',
    'xlUp',
    'onlyXl',
    'lgDown',
    'lgUp',
    'onlyLg',
    'mdDown',
    'mdUp',
    'onlyMd',
    'smDown',
    'smUp',
    'onlySm',
    'xsDown',
    'xsUp',
    'onlyXs'
]);
var _default = exports.default = hiddenCssClasses;
